import React, { useEffect, useState } from "react";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

export default function InventoryLedger() {
  const [rows, setRows] = useState([]);

  const loadLedger = async () => {
    try {
      const res = await fetch(`${API_BASE}/inventory/ledger`, {
        headers: authHeaders(),
      });
      const data = await res.json();

      console.log("LEDGER RAW RESPONSE:", data);
      console.log("LEDGER ARRAY:", data.data);

      // correct extraction
      setRows(Array.isArray(data?.data) ? data.data : []);
    } catch (err) {
      console.error("Error loading inventory ledger:", err);
    }
  };

  useEffect(() => {
    loadLedger();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Product Inventory Ledger</h2>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#ddd" }}>
            <th style={{ padding: "10px" }}>Product</th>
            <th style={{ padding: "10px" }}>Opening</th>
            <th style={{ padding: "10px" }}>Purchase</th>
            <th style={{ padding: "10px" }}>Allocated</th>
            <th style={{ padding: "10px" }}>Sold</th>
            <th style={{ padding: "10px" }}>Closing</th>
          </tr>
        </thead>

        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan="6" style={{ textAlign: "center", padding: "10px" }}>
                No ledger data found
              </td>
            </tr>
          ) : (
            rows.map((r, idx) => (
              <tr key={idx} style={{ borderBottom: "1px solid #ccc" }}>
                <td style={{ padding: "10px" }}>{r.product_name}</td>
                <td style={{ padding: "10px" }}>{r.opening}</td>
                <td style={{ padding: "10px" }}>{r.purchase}</td>
                <td style={{ padding: "10px" }}>{r.allocated}</td>
                <td style={{ padding: "10px" }}>{r.sold}</td>
                <td style={{ padding: "10px" }}>{r.closing}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
